import React, { Component } from "react";
import { FaInstagram, FaFacebookF, FaLine } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import { FiX, FiMenu } from "react-icons/fi";
import { Link } from 'react-router-dom';

// const SocialShare = [
//     { Social: <FaFacebookF />, link: 'https://www.facebook.com/farmchansawangyasothon' },
//     { Social: <FaInstagram />, link: 'https://www.instagram.com/farmchansawangyasothon' },
//     { Social: <SiTiktok  />, link: 'https://www.tiktok.com/@farmchansawangyasothon' },
//     { Social: <FaLine  />, link: 'https://lin.ee/htkgF3M' },
// ]
class Header extends Component {
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);

        //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function () {
            console.log('All assets are loaded');
        })

    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }

    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open')
    }

    stickyHeader() { }
    render() {
        window.addEventListener('scroll', function () {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            } else {
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });
        var elements = document.querySelectorAll('.has-droupdown > a');
        for (var i in elements) {
            if (elements.hasOwnProperty(i)) {
                elements[i].onclick = function () {
                    this.parentElement.querySelector('.submenudesktop').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const { logo, color = 'default-color' } = this.props;
        let logoUrl;
        if (logo === 'light') {
            logoUrl = <img src="/assets/images/logo/logo-light.webp" alt="พิพิธภัณฑ์สิงห์ท่า" />;
        } else {
            logoUrl = <img src="/assets/images/logo/logo.webp" alt="พิพิธภัณฑ์สิงห์ท่า" />;
        }

        return (
            <header className={`header-area header--fixed ${color}`}>
                <div className="header-wrapper">
                    <div className="header-left d-flex align-items-center">
                        <div className="logo">
                            <a href="/">{logoUrl}
                            </a>
                            {/* <a href={this.props.homeLink}>
                                {logoUrl}
                            </a> */}
                        </div>
                        <nav className="mainmenunav d-lg-block ml--50">
                            <ul className="mainmenu">
                                <li className="mobile-contact mb--30 mt--10">
                                    <a href="/">
                                        <img className="w-100" src="/assets/images/logo/logo.webp" alt="พิพิธภัณฑ์สิงห์ท่า" />
                                    </a>
                                    {/* <img className="w-100" src="/assets/images/logo/logo.webp" alt="พิพิธภัณฑ์สิงห์ท่า" /> */}
                                </li>
                                <li><Link to="/" >หน้าหลัก</Link></li>

                                {/* Desktop */}
                                <li className="has-droupdown">
                                    <Link to="/about-us" >เกี่ยวกับเรา ▾</Link>
                                    <ul className="submenudesktop">
                                         <li><Link to="/about-us">พิพิธภัณฑ์สิงห์ท่า </Link></li>
                                        <li><Link to="/museum-history">ประวัติของพิพิธภัณฑ์</Link></li>
                                        <li><Link to="/singhatha-history">ประวัติบ้านสิงท่าห์</Link></li>
                                    </ul>
                                </li>

                                <li className="has-droupdown">
                                    <Link to="/exhibitions" >นิทรรศการและกิจกรรม ▾</Link>
                                    <ul className="submenudesktop">
                                        <li><Link to="/exhibition-floor-1">นิทรรศการชั้น 1</Link></li>
                                        <li><Link to="/exhibition-floor-2">นิทรรศการชั้น 2</Link></li>
                                        <li><Link to="/gallery">แกลเลอรี่</Link></li>
                                    </ul>
                                </li>

                                <li><Link to="/nearby-attractions" >ลัดเลาะรอบเมืองสิงห์ท่า</Link></li>
                              
                                <li><Link to="/contact" >ติดต่อเรา</Link>
                                </li>


                                {/* <li className="mobile-contact mt--50">
                                    <div>
                                        <div className="social-share-inner">
                                            <ul className="social-share-herder color-black d-flex justify-content-center liststyle">

                                                <li className="facebook"><a href="https://www.facebook.com/farmchansawangyasothon" aria-label="facebook"><FaFacebookF /></a></li>
                                                <li className="instagram"><a href="https://www.instagram.com/farmchansawangyasothon" aria-label="instagram"><FaInstagram /></a></li>
                                                <li className="tiktok"><a href="https://www.tiktok.com/@farmchansawangyasothon" aria-label="tiktok"><SiTiktok /></a></li>
                                                <li className="line"><a href="https://lin.ee/htkgF3M" aria-label="line"><FaLine /></a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </li> */}

                            </ul>



                        </nav>
                    </div>
                    <div className="header-right">
                      
                        <div className="humberger-menu d-block d-lg-none pl--20 pl_sm--10">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default Header;
